var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"uv-card"},[_c('div',{staticClass:"uv-card-body"},[_c('ModuleHeader',[_vm._v("Cargar Movimientos")]),_c('MovimientosForm',{key:_vm.formIndex,attrs:{"membresia":_vm.membresia_id,"edit":_vm.editMode,"dataEdit":_vm.editData},on:{"toggle":_vm.toggleModal,"successData":_vm.successData}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }